import {DeleteRounded, DownloadRounded, Visibility, VisibilityOff} from "@mui/icons-material";
import { downloadDocumentsRs} from "../../../../search-repair-shop/rsSearch.actions";
import { useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {saveAs} from "file-saver";
import AgGridCustomTable from "../../../../../../util/component/AgGridCustomTable";
import { ColDef } from "ag-grid-community";
import { IconButton } from "@mui/material/index";
import DeleteFileDialog from "./DeleteFileDialog";
import { GlobalContext } from "../../../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../../../util/state/globalVariables";
import ShowFileDialog from "./ShowFileDialog";
import { GenericFile, IDocumentGrid } from "./types";

const DocumentGrid = ({list, isDisabled}: IDocumentGrid) => {
    const {t} = useTranslation(['network', 'translation']);
    const [deleteFile, setDeleteFile] = useState<GenericFile>(null);
    const [showFile, setShowFile] = useState<GenericFile>(null);

    const {dispatchGlobalData} = useContext(GlobalContext);

    const downloadHandler = (idDoc: number) => {
        downloadDocumentsRs({idDoc})
            .then((response: any) => {
                if (!!response) {
                    const {mimeType, file, fileName} = response
                    saveAs(`data:${mimeType};base64,${file}`, fileName);
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: t('rsDetail.documentRepositoryDms.dialog.downloadSuccess'),
                                type: snackbarTypes.success,
                                show: true,
                                autoClose: true,
                            }
                        }
                    });
                }
            }).catch(() => {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t('error.tryLater'),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            });
    }

    const hasPreview = (mimeType: string) => mimeType === 'application/pdf' || mimeType.startsWith('image/');

    const columnDefs = useMemo<ColDef[]>(() => [
        {
            field: 'fileName',
            headerName: t(`rsDetail.documentRepositoryDms.labels.fileName`),
        },
        {
            field: 'uploadDate',
            headerName: t(`rsDetail.documentRepositoryDms.labels.uploadDate`),
        },
        {
            field: 'actions',
            headerName: '',
            maxWidth: 150,
            resizable: false,
            suppressMovable: true,
            suppressSizeToFit: false,
            suppressColumnsToolPanel: true,
            pinned: 'right',
            cellRenderer: (p: any) => (
                <>
                    {hasPreview(p.data.mimeType) ? (
                        <IconButton color="accent" onClick={() => setShowFile(p.data)}>
                            <Visibility />
                        </IconButton>
                    ) : ( 
                        <IconButton disabled>
                            <VisibilityOff />
                        </IconButton>
                    )}
                    <IconButton color="accent" onClick={() => downloadHandler(p.data.idDoc)}>
                        <DownloadRounded />
                    </IconButton>
                    {!isDisabled && (
                        <IconButton color="accent" onClick={() => setDeleteFile(p.data)}>
                            <DeleteRounded />
                        </IconButton>
                    )}
                </>
            )
        }
    ], [isDisabled]);

    return (
        <>
            <AgGridCustomTable
                rowData={list}
                pagination={false}
                columnDefs={columnDefs}
                containerStyle={{maxHeight: '600px', overflow: 'auto', marginTop: '8px', marginBottom: '8px'}}
            />
            <DeleteFileDialog deleteFile={deleteFile} setDeleteFile={setDeleteFile} />
            <ShowFileDialog file={showFile} setFile={setShowFile} downloadHandler={downloadHandler} setDeleteFile={setDeleteFile} />
        </>
    )
}

export default DocumentGrid;
